var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "30px",
    viewBox: "0 0 19 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02.Icons / Basic / Line / Chervon / Right Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.0_Template_09-Copy-23",
    transform: "translate(-210.000000, -473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(130.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Line-/-Chervon-/-Right-Copy",
    transform: "translate(60.000000, 408.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "currentColor",
    points: "38.525 18.525 35 15 20 30 35 45 38.525 41.475 27.075 30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreArrowIcon);
export default __webpack_public_path__ + "static/media/PreArrowIcon.54d50f884ffb6d0c4481fafd05372e34.svg";
export { ForwardRef as ReactComponent };